// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { post } from "@insite/client-framework/Services/ApiService";
import { GetProductCollectionRealTimeInventoryApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import { RealTimeInventoryModel } from "@insite/client-framework/Types/ApiModels";

const realTimeInventoryUrl = "/api/v1/realtimeinventory";

export function xGetProductCollectionRealTimeInventory(parameter: GetProductCollectionRealTimeInventoryApiV2Parameter) {
    let url = realTimeInventoryUrl;
    let queryString = "";
    if (parameter.expand) {
        url += `?expand=${parameter.expand.join(",")}`;
        queryString = "&"
    } else {
        queryString = "?"
    }

    if (parameter.additionalQueryStringParameters) {
        const queryParams = parameter.additionalQueryStringParameters;
        queryString = queryString + Object.keys(queryParams)
            .map(key => {
                return `${encodeURIComponent(key)}=${encodeURIComponent(queryParams[key])}`;
            })
            .join("&");
    }

    return post<GetProductCollectionRealTimeInventoryApiV2Parameter, RealTimeInventoryModel>(`${url}${queryString.length > 0 ? `${queryString}` : ""}`, {
        productIds: parameter.productIds,
        configurations: parameter.configurations,
    });
}